module.exports = __webpack_public_path__ + "static/media/YellowBG.a450ed48.svg";